import { getReq, putReq } from '../utils/request'
import { Response } from '../types/api'
import { Settings } from '../types/data'

export default {
	loadSettings: (): Response<Settings> => getReq('/api/admin/settings', {}),
	updateSettings: (data: object) => putReq('/api/admin/settings', {}, data, {})
}
